module.exports = __webpack_public_path__ + "static/media/af_lab_miniatura_fb_01.ec243bd5.png";